import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Typography, Icon, Row, Col, Spin, Card, Tag, Select, Radio, Input, Form, Button, Pagination } from 'antd'
import { Queries  } from '../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../components/user/Container'
import QualityDocumentDetail from '../../../components/user/QualityDocumentDetail'
import PolicyDocumentsDetail from '../../../components/user/PolicyDocumentsDetail'
import Search from '../../../components/user/Search'

//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import { changeFormatdate } from '../../../utils/formatdate'

const { Text, Title } = Typography
const InputGroup = Input.Group;

class PolicyQualityDocument extends React.Component {

    state = {
        detailDocument: [],
        visibleModal: false,
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        showModalErrors: false,
        listSelectAll: [],
        listSelect1: [],
        listSelect2:[],
        selectSearch: "type",
        preload: false,
        numberCol: "24",
        showDetail:"search",
        detailPolicy:null,
        dataFirstPage:true,
        valueSelect1: null,
        valueSelect2: null,
        widthSelectType:"25%",
        valuesForm:null,
        offset: 0,
        limit: 10,
        total: 10,
        current:1
    }

    fetchListKCMHQualityDocument = async (values) => {
        const { client, location } = this.props
        const { selectMonth, selectYear, offset, limit } = this.state
        // console.log(values)
        this.setState({
            preload:true
        })
        
        let divisionId = ""
        let docTypeId = ""
        
       if(values.docTypeIdAll){
            divisionId = "ALL"
            docTypeId = values.docTypeIdAll == "ALL" ? null : values.docTypeIdAll
        }else{
            divisionId = values.divisionId
            docTypeId = values.docTypeId ? values.docTypeId : null
        }


        // console.log('divisionId',divisionId)
        // console.log('docTypeId',docTypeId)

        const { data, errors } = await client.query({
            query: Queries.fetchListKCMHQualityDocumentList,
            variables: {
                divisionId,
                docTypeId,
                search: values.search,
                offset,
                limit
            }
        })
       
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            await this.setState({
                showModalErrors: true
            })
        }

        console.log('data',data)
        let dataDocument = [];
        if(data.fetchListKCMHQualityDocument.data.length !== 0){
            data.fetchListKCMHQualityDocument.data.map((value, keys) =>{
                dataDocument[keys] = {
                                        'id': value.docId,
                                        'title': value.docTitle,
                                        'activeDate': value.activeDate,
                                        'systemName' : value.systemName ? value.systemName : '',
                                        'updatedAt': value.updatedAt,
                                        'status': value.status,
                                    }
            })

            await this.setState({
                detailDocument: dataDocument,
                preload: false,
                showDetail:"search",
                total: data.fetchListKCMHQualityDocument.total,
                valuesForm:values
            })
        }else{
            await this.setState({
                detailDocument:[],
                preload: false,
                showDetail:"search",
                total: 0,
                valuesForm:values
            })
        }
      
    }

    fetchListKCMHDocumentDetail = async (docId) => {
        const { client } = this.props
        const { data, errors } = await client.query({
            query: Queries.fetchListKCMHQualityDocument,
            variables: {
                docId
            }
        })

        //////////////////////addmodalINTERNAL_SERVER_ERROR
        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            await this.setState({
                showModalErrors: true
            })
        }
        await this.setState({
            detailPolicy: data.fetchListKCMHQualityDocument.data[0],
            showDetail:"showData"
        })
    }

    fetchListDocumentTypeMasterData= async (divisionId) => {
        const { client, location } = this.props
        const { selectMonth, selectYear } = this.state
        // console.log(divisionId)
        const { data, errors } = await client.query({
            query: Queries.fetchListDocumentTypeMasterData,
            variables: {
                divisionId
            }
        })

        //////////////////////addmodalINTERNAL_SERVER_ERROR
        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            await this.setState({
                showModalErrors: true
            })
        }

        if(data.fetchListDocumentTypeMasterData){
            if(divisionId == 'ALL'){
                await this.setState({
                    listSelectAll: data.fetchListDocumentTypeMasterData,
                    listSelect2:[]
                })
            }else{
                await this.setState({
                    listSelect2: data.fetchListDocumentTypeMasterData,
                })
            }
        }else{
            await this.setState({
                listSelectAll: [],
                listSelect2:[]
            })
        }
        
    }

    fetchListDropDownDivisionCDMasterData = async ()=>{
        const { client, location } = this.props
        const { selectMonth, selectYear } = this.state

        const { data, errors } = await client.query({
            query: Queries.fetchListDropDownDivisionCDMasterData,
        })
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            await this.setState({
                showModalErrors: true
            })
        }

        this.setState({
            listSelect1: data.fetchListDropDownDivisionCDMasterData
        })
    }

    onSearchData = (values) =>{
        this.fetchListDocumen(values)
    }

    fetchlistSelect1 = async() =>{
        const { client } = this.props

        try {
            const { data, errors } = await client.query({
                query: Queries.fetchlistSelect1,
            })
            await this.setState({ listSelect1: data.fetchlistSelect1});

        } catch (error) {
            console.log('error', error)
        }
    }

    handleSubmit = e => {
		const { form, afterSubmit } = this.props
		e.preventDefault()
		form.validateFields(async (err, values) => {
			if (!err) {
                await this.setState({
                    current:1,
                    offset:0
                })
                
				await this.fetchListKCMHQualityDocument(values)
			}
		})
    }

    onChangeSelectSearch = (e) =>{
        let numberCol = ""
        let widthSelectType = ""
        if(e == 'type'){
            numberCol = "24"
            widthSelectType = '25%'
        }else{
            numberCol = "14"
            widthSelectType = '40%'
        }
        this.setState({
            selectSearch: e,
            detailDocument:[],
            numberCol,
            widthSelectType,
            valueSelect1:null,
            valueSelect2:null,
            listSelect2:[]
        })

    }
    
    onChangeSelect1 = async(e) =>{
        const { listSelect1 } = this.state
        this.setState({
            valueSelect1:e
        })
        
        this.props.form.resetFields("docTypeId")

        await this.fetchListDocumentTypeMasterData(e)
    }

    clearInput = ()=>{
        this.props.form.resetFields();
        this.setState({
            valueSelect1:null,
            valueSelect2:null,
            listSelect2:[],
            dataFirstPage:true,
            detailDocument:[],
            detailPolicy:null,
            showDetail:'search'
        })
    }

    onChangePagination = async page => {
		const { limit, valuesForm, detailDocument } = this.state

        let offset = limit * (page - 1)
        await this.setState({
            offset,
            detailDocument:[],
            preload:true,
            current: page
        });

        
        let values = valuesForm

        if(detailDocument.length == 0){
            values = {
                docTypeIdAll: "ALL"
            }
        }
        
        await this.fetchListKCMHQualityDocument(values)
    };

    setDisbleButton = () =>{
        const { selectSearch, valueSelect1, valueSelect2 } = this.state

        if(selectSearch == 'type'){
            return valueSelect1 ? false : true
        }else{
            return valueSelect1 ? false : true
        }
    }

    checkDisbleSearch = () => {
        const { selectSearch, valueSelect1, valueSelect2 } = this.state
        console.log('valueSelect1',valueSelect1)
        if(selectSearch == 'type'){
            if(valueSelect1){
                return false
            }else{
                return true
            }
        }else{
            if(valueSelect1 && valueSelect2){
                return false
            }else{
                return true
            }
        }
    }

    async componentDidMount() {
        const values = {
            docTypeIdAll: "ALL"
        }
        await this.fetchListKCMHQualityDocument(values)
        await this.fetchListDropDownDivisionCDMasterData()
        await this.fetchListDocumentTypeMasterData("ALL")
    }  

    render() {
        const { match, location, form } = this.props
        const { 
                detailDocument, 
                listSelect1, 
                listSelect2, 
                preload, 
                selectSearch, 
                listSelectAll, 
                numberCol,
                showDetail,
                detailPolicy, 
                dataFirstPage,
                widthSelectType,
                current,
                total,
                valuesForm
            } = this.state
        const { getFieldDecorator } = form

        // console.log(valuesForm)
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <div id="page-policy-hr">
                    <Form onSubmit={this.handleSubmit} className="mb-3 pb-3">
                        <Row gutter={16}>
                            <Col span={ numberCol }>
                                <InputGroup compact>
                                    <Select defaultValue={ selectSearch } onChange={ this.onChangeSelectSearch } style={{ width:widthSelectType }}>
                                        <Select.Option value="type">ค้นหาตามประเภทเอกสาร</Select.Option>
                                        <Select.Option value="division">ค้นหาตามฝ่าย/หน่วยงาน</Select.Option>
                                    </Select>
                                    {
                                        selectSearch == 'type' &&
                                            getFieldDecorator('docTypeIdAll', {
                                                rules: [{ required: true, message: 'กรุณาเลือกประเภทเอกสาร' }]
                                            })(
                                                <Select 
                                                    style={{ width:"75%" }} 
                                                    onChange={ () => this.setState({
                                                        valueSelect1:true
                                                    })}
                                                    placeholder="ประเภทเอกสาร"
                                                >
                                                    <Select.Option value={'ALL'}>ทั้งหมด</Select.Option>
                                                    {
                                                        listSelectAll.length !== 0 &&
                                                        listSelectAll.map((value,key) =>{
                                                            return <Select.Option  value={value.docTypeId}>{value.docTypeName}</Select.Option>
                                                        })
                                                    }
                                                </Select>
                                            )
                                        ||
                                        getFieldDecorator('divisionId', {
                                            rules: [{ required: true, message: 'กรุณาเลือกค้นหาตามฝ่าย' }]
                                        })(
                                            <Select 
                                                onChange={ this.onChangeSelect1 } 
                                                style={{ width:"60%" }}
                                                placeholder="ฝ่าย/หน่วยงาน"
                                            >
                                                <Select.Option value={'ALL'}>ทั้งหมด</Select.Option>
                                                {
                                                    listSelect1.map((value,key) =>{
                                                        return <Select.Option  value={value.id}>{value.name}</Select.Option>
                                                    })
                                                }
                                            </Select>
                                        )
                                    }
                                </InputGroup>
                            </Col>
                            {
                                selectSearch !== 'type' &&
                                    <Col span={10}>
                                        {/* <Form.Item label={<b>ค้นหาตามฝ่าย</b>} name="divisionId" className="mb-2"> */}
                                            {getFieldDecorator('docTypeId', {
                                                // rules: [{ required: true, message: 'กรุณาเลือกประเภทเอกสาร' }]
                                            })(
                                                <Select 
                                                    disabled={ listSelect2.length === 0 ? true : false }
                                                    onChange={ () => this.setState({
                                                        valueSelect2:true
                                                    })}
                                                    placeholder="ประเภทเอกสาร"
                                                >
                                                    <Select.Option value={'ALL'}>ทั้งหมด</Select.Option>
                                                    {
                                                        listSelect2.map((value,key) =>{
                                                            return <Select.Option  value={value.docTypeId}>{value.docTypeName}</Select.Option>
                                                        })
                                                    }
                                                </Select>
                                            )}
                                        {/* </Form.Item> */}
                                    </Col>
                            }
                            <Col span={8} className="mt-3">
                                {getFieldDecorator('search', {
                                        rules: [{ required: false }]
                                    })(
                                        <Input
                                            disabled={ this.checkDisbleSearch() }
                                            placeholder=""
                                            suffix={
                                                <Icon type="search" style={{ color: 'rgba(0,0,0,.45)' }}/>
                                            }
                                        />
                                    )}
                            </Col>
                            <Col span={16} style={{ textAlign:"right" }} className="mt-3">
                                <Button type="primary" className="color-white text-right mr-3" style={{ backgroundColor:"#bbc5c5" }} onClick={this.clearInput}>
                                    ล้างค่า
                                </Button>
                                <Button 
                                    type="primary" 
                                    htmlType="submit" 
                                    className="color-white text-right"
                                    disabled={ this.setDisbleButton() }
                                >
                                    <Icon type="search" /> ค้นหา
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                    {
                        showDetail == 'search' &&
                        <>
                            {
                                detailDocument.length !== 0 &&
                                    <>
                                        <QualityDocumentDetail detailDocument={detailDocument} categoryName="Quality" fetchListKCMHDocumentDetail={this.fetchListKCMHDocumentDetail}/>
                                    </>
                                ||
                                preload &&
                                    <div style={{ textAlign: 'center', borderRadius: "10px", height: "130px" }}>
                                        <Icon type="loading" />
                                    </div>
                                ||
                                !dataFirstPage && 
                                <div style={{ textAlign: 'center', borderRadius: "10px", height: "130px" }}>
                                    <Text className="color-gray" >ไม่พบข้อมูล</Text>
                                </div>
                            }
                            {
                                detailDocument.length !== 0 &&
                                    <Pagination current={current} onChange={this.onChangePagination} total={total}/>
                            }
                        </>
                        ||
                        <PolicyDocumentsDetail detailPolicy={detailPolicy}/>
                        
                    }
                </div>
            </Container>
        )
    }
}

PolicyQualityDocument.defaultProps = {
	autoFocus: false
}

PolicyQualityDocument.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedPolicyQualityDocument = Form.create()(PolicyQualityDocument)

export default withApollo(WrappedPolicyQualityDocument)